/**
 * @format
 */
import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupIcon from '@mui/icons-material/Group';
import Signup from './CreateNewUser/components/Signup';
import UserList from './components/UserList';
import ManagementPage from '../shared/ManagementPage';
import { useUserPage } from './hooks/useUserPage';

const USER_TABS = [
  { value: 0, icon: <PersonIcon />, label: 'User List' },
  { value: 1, icon: <GroupAddIcon />, label: 'Signup' },
];

export default function Users() {
  const {
    tabIndex,
    setTabIndex,
    users,
    selectedUser,
    setSelectedUser,
    isEditing,
    setIsEditing,
    loading,
    error,
    formData,
    setFormData,
    snackbar,
    handleFormSuccess,
    handleChange,
    handleUpdate,
    handleSnackbarClose,
    fetchUsers,
  } = useUserPage();

  return (
    <ManagementPage
      title="User Management"
      icon={<GroupIcon />}
      tabs={USER_TABS}
      tabIndex={tabIndex}
      onTabChange={setTabIndex}
      snackbar={snackbar}
      onSnackbarClose={handleSnackbarClose}
    >
      {tabIndex === 0 &&
        (loading ? (
          <Box display="flex" justifyContent="center" minHeight="28vh">
            <CircularProgress size={26} sx={{ color: 'white' }} />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <UserList
            users={users}
            selectedUser={selectedUser}
            isEditing={isEditing}
            setSelectedUser={setSelectedUser}
            setIsEditing={setIsEditing}
            setFormData={setFormData}
            formData={formData}
            fetchUsers={fetchUsers}
            handleChange={handleChange}
            handleUpdate={handleUpdate}
            onFormSuccess={handleFormSuccess}
          />
        ))}

      {tabIndex === 1 && <Signup />}
    </ManagementPage>
  );
}
